const initialState = {
  tagsList: [],
};

export const tagsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "tags")
    return action.execute(state);
  return state;
};
